import React, { useRef, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "@mui/material";
import SuiAvatar from "components/SuiAvatar";
import GroupIcon from "@mui/icons-material/Group";
import { AccountContext } from "context/account";

export const getChatTooltip = (room) => {
  var tooltip = "";
  if (room?.contacts) {
    room?.contacts.sort((a, b) => (a.name < b.name ? -1 : 1));
    for (const contact of room?.contacts) {
      if (contact.type == 1) {
        continue;
      }
      tooltip = tooltip + contact.name + "\n";
    }
  } else tooltip = room.username;
  return tooltip;
};

const ContactAvatar = ({ room, contact, size = "sm", profile = true }) => {
  var avatar = room ? room?.avatar : contact?.avatar;
  var tooltip = room ? getChatTooltip(room) : contact?.name;
  if (!tooltip) {
    tooltip = contact?.username;
  }
  const ContactTooltip = () => {
    return (
      <Tooltip
        title={
          <div style={{ whiteSpace: "pre-line" }} sx={{ cursor: "pointer" }}>
            {tooltip}
          </div>
        }
      >
        {avatar != "" ? (
          <SuiAvatar
            src={avatar}
            alt="profile-image"
            variant="rounded"
            size={size}
            shadow="sm"
            bgColor="info"
          />
        ) : (
          <SuiAvatar alt="profile-image" variant="rounded" size={size} shadow="sm" bgColor="info">
            <GroupIcon fontSize="medium" />
          </SuiAvatar>
        )}
      </Tooltip>
    );
  };
  var accounttype = room ? room.contactaccounttype : contact.accounttype;
  var contactid = room ? room.contactid : contact.id;
  const account = useContext(AccountContext);
  let userid = account.id;
  if (contactid == userid) accounttype = "";
  if (accounttype == "ma" && profile)
    return (
      <Link
        to={`/wall/portfolio/${contactid}`}
        target="_blank"
        style={{ color: "inherit" }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <ContactTooltip />
      </Link>
    );
  if (accounttype == "de" && profile)
    return (
      <Link
        to={`/wall/portfolio/${contactid}`}
        target="_blank"
        style={{ color: "inherit" }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <ContactTooltip />
      </Link>
    );
  return <ContactTooltip />;
};

export default ContactAvatar;
